"use strict";

exports.__esModule = true;
exports.default = void 0;

var _Context = _interopRequireDefault(require("./Context"));

var _react = _interopRequireDefault(require("react"));

var _config = _interopRequireDefault(require("../../config"));

var _jsxFileName = "C:\\github\\os\\react-most-wanted\\packages\\rmw-shell\\src\\contexts\\AppConfigProvider\\withAppConfigs.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const withAppConfigs = Component => {
  const ChildComponent = props => {
    return (/*#__PURE__*/_react.default.createElement(_Context.default.Consumer, {
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 8,
          columnNumber: 7
        }
      }, value => {
        const _ref = value || {},
              appConfig = _ref.appConfig;

        return (/*#__PURE__*/_react.default.createElement(Component, _extends({
            appConfig: _extends({}, _config.default, {}, appConfig)
          }, props, {
            __self: void 0,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 11,
              columnNumber: 18
            }
          }))
        );
      })
    );
  };

  return ChildComponent;
};

var _default = withAppConfigs;
exports.default = _default;
module.exports = exports.default;